import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'
import htmlUtil from '@/utilities/html'
import userAgent from '@/utilities/userAgent'

export const useClientStore = defineStore('client', () => {
  interface ClientInfo {
    csrfParam?: string,
    csrfToken?: string,
    isApp?: boolean,
    isTouchDevice?: boolean,
  }
  const context: ClientInfo = reactive({
    csrfParam: '',
    csrfToken: '',
    isApp: false,
    isTouchDevice: false,
  })

  const trackingCodePrefix = computed<string>(() => context.isApp ? 'app' : 'brw')

  const trackingCodeParam = (suffix: string): QueryParameter => ({
    name: 'trcd',
    value: `${trackingCodePrefix.value}_${suffix}`,
  })

  const setIsTouchDevice = () => {
    context.isTouchDevice = userAgent.isAndroid() || userAgent.isIos() || context.isApp
  }

  const setCSRFParam = (param: string) => {
    context.csrfParam = param
  }

  const setCSRFToken = (token: string) => {
    context.csrfToken = token
  }

  /**
   * CSRF 情報の初期設定
   */
  const initCSRFInfo = () => {
    const csrfParam = htmlUtil.getMeta('[name="csrf-param"]')
    const csrfToken = htmlUtil.getMeta('[name="csrf-token"]')

    if (csrfParam) setCSRFParam(csrfParam)
    if (csrfToken) setCSRFToken(csrfToken)
  }

  initCSRFInfo()


  return {
    // data
    context,

    // computed
    trackingCodePrefix,

    // methods
    trackingCodeParam,
    setCSRFParam,
    setCSRFToken,
    setIsTouchDevice,
  }
})
